import { FC, useEffect } from 'react';
import { FallbackRender } from '@sentry/react/build/types/errorboundary';
import { useTranslation } from 'react-i18next';
import { Box, SxProps, Typography } from '@mui/material';
import OwlIcon from '@shared/static/icons/OwlIcon';

interface ErrorBoundaryFallbackProps {
    errorData?: Parameters<FallbackRender>[0];
    style?: SxProps;
}

const ErrorBoundaryFallback: FC<ErrorBoundaryFallbackProps> = ({ errorData, style }) => {
    const { t } = useTranslation();
    const { resetError } = errorData ?? {};

    useEffect(() => {
        return () => {
            resetError && resetError();
        };
    }, [resetError]);

    return (
        <Box
            sx={{
                padding: 2,
                minWidth: 700,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                whiteSpace: 'pre-wrap',
                textAlign: 'center',
                ...style,
            }}
        >
            <OwlIcon />
            <Typography sx={{ fontSize: '3rem', fontWeight: 600 }}> {t('unhandled_error_message') + '\n'}</Typography>
            <Typography sx={{ fontSize: '1.5rem', fontWeight: 600 }}>{t('we_know_about_error_message')}</Typography>
        </Box>
    );
};

export default ErrorBoundaryFallback;
